<template>
  <div>
    <vs-row>
      <form-label>{{ $t('GradeControl.Timesheet.UserComments') }}</form-label>
      <vs-textarea 
        v-model="userComments" 
        class="w-full"  
        height="300px"
        name="userComments" />
    </vs-row>
    <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button class="mr-6" @click="submitData()">{{$t("Submit")}}</vs-button>
      <vs-button type="border" color="danger" @click="cancel()">{{$t("Cancel")}}</vs-button>
    </vs-row>
  </div>
</template>

<script>
import {
  FormLabel
} from "./../../../../shared/components";

export default {
  props: {
    timesheet: {
      type: Object
    }
  },
  components: {
    FormLabel
  },
  data() {
    return {
      userComments : ""
    };
  },
  watch: {
    timesheet(val) {
      if (val) {
        this.userComments = val.userComments;
      } else {
        this.initValues();
      }
    }
  },
  methods: {
    initValues() {
      this.selectedUserComments =  "";
    },
    cancel() {
      this.$emit("onCancel");
    },
    submitData() {
      this.$emit("onSaved", this.$props.timesheet.timesheetStagingEntryId, this.userComments);
    }
  }
};
</script>
